module.exports = __webpack_public_path__ + "img/pm.71a02434.png";